import { useState, useEffect } from 'react';
import { api } from '@shared/api';

interface Project {
    id: number;
    name: string;
    description: string;
    created_at: string;
}

interface Stats {
    projects: number;
    sequences: number;
    variants: number;
    jobs_running: number;
}

export function DashboardPage() {
    const [projects, setProProjects] = useState<Project[]>([]);
    const [stats, setStats] = useState<Stats | null>(null);

    useEffect(() => {
        api.get<{ projects: Project[] }>('/projects')
            .then(data => setProProjects(data.projects))
            .catch(() => { });
        api.get<Stats>('/stats')
            .then(setStats)
            .catch(() => { });
    }, []);

    return (
        <div className="animate-in">
            <header className="page-header">
                <h1 className="page-title">Dashboard</h1>
                <p className="page-subtitle">Overview of your genomic analysis projects</p>
            </header>

            <div className="grid grid-4" style={{ marginBottom: 32 }}>
                <StatCard label="Projects" value={stats?.projects ?? '—'} />
                <StatCard label="Sequences" value={stats?.sequences ?? '—'} />
                <StatCard label="Variants Found" value={stats?.variants ?? '—'} />
                <StatCard label="Running Jobs" value={stats?.jobs_running ?? '—'} />
            </div>

            <div className="card">
                <div className="card-header">
                    <h2 className="card-title">Recent Projects</h2>
                    <button className="btn btn-primary">+ New Project</button>
                </div>
                {projects.length === 0 ? (
                    <p style={{ color: 'var(--color-text-dim)' }}>No projects yet</p>
                ) : (
                    <div className="grid grid-3">
                        {projects.map(p => (
                            <ProjectCard key={p.id} project={p} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

function StatCard({ label, value }: { label: string; value: string | number }) {
    return (
        <div className="card">
            <div className="stat-value">{value}</div>
            <div className="stat-label">{label}</div>
        </div>
    );
}

function ProjectCard({ project }: { project: Project }) {
    return (
        <div className="card">
            <h3 style={{ marginBottom: 8 }}>{project.name}</h3>
            <p style={{ color: 'var(--color-text-dim)', fontSize: '0.9rem' }}>
                {project.description || 'No description'}
            </p>
            <div style={{ marginTop: 16 }}>
                <span className="badge badge-info">Active</span>
            </div>
        </div>
    );
}
